/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from '@module-logger/mbp';
import restClient from '../../app/helpers/restClient';
import { getAccessTokenSafely } from '../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';

export const fetchUserDetailsByEmailApi = async (body) => {
    const token = await getAccessTokenSafely();
    const wcEnv = { rootUri: '/' };
    const resourcePage = 'profile/auth0/checkuser';
    let data = {
        status: false,
        name: '',
    };

    try {
        const usersReponse = await restClient.postFacade(wcEnv, resourcePage, token, body);
        const userData = usersReponse?.data;
        data = {
            ...userData,
            status: true,
            name: userData?.firstName,
            code: usersReponse.status,
        };
        return data;
    } catch (err) {
        data = {
            ...data,
            code: err.status,
        };
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            jsError: err,
            message: 'fetchUserDetailsByEmailApi: Error while fetching user details.',
        });
        return data;
    }
};

export default {};
